import type { TranslateServerSideState } from '../types';

/**
 * 获取翻译任务状态的能力
 */
export interface GetTranslateServerSideStateService {
    /**
     * 获取翻译任务状态
     * @param taskId 任务ID
     * @returns 翻译任务状态
     */
    getTranslateServerSideState: (taskId: string) => Promise<TranslateServerSideState>;
    /**
     * 拉取翻译任务状态, 并更新翻译任务状态至 {@link TranslateServerSideModel}
     * @param taskId 任务ID
     * @returns 翻译任务状态
     */
    pullTranslateServerSideState: (taskId: string) => Promise<void>;
}

export const GetTranslateServerSideStateService = Symbol('GetTranslateServerSideStateService');
